export default __webpack_public_path__ + "static/media/DS24.491658d7.JPG";